import { getFloatNumberRoundValue } from '@utils_iqfu/getFloatNumberRoundValue';

//㎡を坪面積に変換した値を返す 第二引数は丸める小数点の桁数
export const getConvertedTsuboValue = (base_number: number, decimalPlaces: number) => {
  return getFloatNumberRoundValue(base_number / 3.30578, decimalPlaces);
};
